import { createReducer, on } from '@ngrx/store';
import { SunbedForm, SunbedState, Zone } from '@shared-models';
import {
  addSunbedToCartAction,
  removeSunbedFromCartAction,
  setEnabledReservationsAction,
  showSunbedCartAction,
  sunbedPrereservationAction,
} from '@store-sunbed-actions';

export const initialSunbedState: SunbedState = {
  formData: {} as SunbedForm,
  zone: {} as Zone,
  zoneIndex: -1,
  cartItems: [],
  displayCart: false,
  reservationsEnabled: true,
  lastCartId: '',
};

export const sunbedReducer = createReducer(
  initialSunbedState,
  on(sunbedPrereservationAction, (state, action) => ({
    ...state,
    formData: action.formData,
    zone: action.zone,
    zoneIndex: action.zoneIndex,
  })),

  on(addSunbedToCartAction, (state, action) => ({
    ...state,
    cartItems: [...state.cartItems, action.sunbed],
    lastCartId: state.lastCartId === '' ? action.sunbed.cartId : state.lastCartId,
  })),

  on(removeSunbedFromCartAction, (state, action) => {
    const items = [...state.cartItems];
    const toBeRemoved = items.find(item => item.id === action.sunbed.id);
    if (toBeRemoved) {
      items.splice(items.indexOf(toBeRemoved), 1);
    }
    return {
      ...state,
      cartItems: [...items],
    };
  }),

  on(showSunbedCartAction, (state, action) => ({
    ...state,
    displayCart: action.display,
  })),

  on(setEnabledReservationsAction, (state, action) => ({
    ...state,
    reservationsEnabled: action.enabled,
  })),
);
